import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { Injectable } from '@angular/core';



//@TODO sprawdzic czy wykorzystywany jest ten serwis bo chyba nie
@Injectable()
export class ErrorService {

  constructor(
    private translateService: TranslateService,
    private notificationsService: NotificationsService
  ) { }

  /**
   * Wyswietla toast z bledem
   * 
   * @param {string} key 
   * 
   * @memberOf ErrorService
   */
  public error(key: string): void {
    let keys: Array<string> = ['UPS', key]
    let translatedMessages = this.translateService.instant(keys);
    this.notificationsService.error(translatedMessages[0], translatedMessages[1]);
  }

  /**
   * Wyswietla toast z informacja o prawidlowym wykonaniu
   * 
   * @param {string} key 
   * 
   * @memberOf ErrorService
   */
  public success(key: string): void {
    let keys: Array<string> = ['SUCCESS', key]
    let translatedMessages = this.translateService.instant(keys);
    this.notificationsService.error(translatedMessages[0], translatedMessages[1]);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/error.service.ts